import React from 'react';

export default function OpportunitySummary({
  heading,
  value,
}: {
  heading: string;
  value: React.ReactNode;
}) {
  return (
    <div className="flex flex-col rounded-lg border border-grey-300 p-4">
      <h3 className="pb-1 type-body1">{heading}</h3>
      <div className="truncate text-2xl font-semibold">{value}</div>
    </div>
  );
}
